import React, { Component, cloneElement } from 'react';
import { List, CreateButton, Datagrid, TextField, DateField, ReferenceField, EditButton, DeleteButton, TopToolbar, RefreshButton, AutocompleteInput, Filter, ReferenceInput, SelectInput, NumberInput } from 'react-admin';
import { Scrollbars } from 'react-custom-scrollbars';
import { GetCurrentUserRoles, monthList } from '../common/common';

import Modal from 'react-responsive-modal';

const BusinesstargetsFilter = (props) => {
    const noOftargets = [...Array(3).keys()];
    return (
        <Filter {...props}>
            <ReferenceInput label="Sold To" source="business_id" reference="businesses" linkType="show" allowEmpty>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <SelectInput source="month" label="Month" choices={[
                { id: 1, name: 'January' },
                { id: 2, name: 'February' },
                { id: 3, name: 'March' },
                { id: 4, name: 'April' },
                { id: 5, name: 'May' },
                { id: 6, name: 'June' },
                { id: 7, name: 'July' },
                { id: 8, name: 'August' },
                { id: 9, name: 'September' },
                { id: 10, name: 'October' },
                { id: 11, name: 'November' },
                { id: 12, name: 'December' },
            ]} />
            <SelectInput source="year" label="Year" choices={[
                { id: 2020, name: '2020' },
                { id: 2021, name: '2021' },
            ]} />

            <NumberInput source="target_lt_0" label="Target 1 less than" />
            <NumberInput source="target_gt_0" label="Target 1 greater than" />
            <NumberInput source="rebate_lt_0" label="Rebate 1 less than" />
            <NumberInput source="rebate_gt_0" label="Rebate 1 greater than" />

            <NumberInput source="target_lt_1" label="Target 2 less than" />
            <NumberInput source="target_gt_1" label="Target 2 greater than" />
            <NumberInput source="rebate_lt_1" label="Rebate 2 less than" />
            <NumberInput source="rebate_gt_1" label="Rebate 2 greater than" />

            {/* {
                noOftargets.map((item, index) => (
                    <NumberInput id={index} source={`target_gt_${index}`} label={`Target  ${index + 1} greater than`} />
                ))
            }
            {
                noOftargets.map((item, index) => (
                    <NumberInput id={index} source={`target_lt_${index}`} label={`Target  ${index + 1} less than`} />
                ))
            }

            {
                noOftargets.map((item, index) => (
                    <NumberInput id={index} source={`rebate_gt_${index}`} label={`Rebate  ${index + 1} greater than`} />
                ))
            }
            {
                noOftargets.map((item, index) => (
                    <NumberInput id={index} source={`rebate_lt_${index}`} label={`Rebate  ${index + 1} less than`} />
                ))
            } */}
        </Filter>
    )
}


// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const ListActions = ({ resource, basePath, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
    let roleData = GetCurrentUserRoles();
    let createBtn = false;
    if (roleData.indexOf("$csa") > -1 || roleData.indexOf("$ca") > -1) {
        createBtn = true
    }
    return (
        <TopToolbar>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <RefreshButton />
            {/* <ImportButton /> */}
            {
                createBtn &&
                <CreateButton label="Import" basePath={basePath} />
            }
            {/* <ExportButton
        disabled={total === 0}
        resource={resource + '_csv'}
        sort={currentSort}
        filter={{ ...filterValues, ...permanentFilter }}
        exporter={exporter}
        maxResults={maxResults}
      /> */}
        </TopToolbar>
    )
}

const Target = ({ record = {}, source, index }) => {
    return (
        <span>{record.target_data[index] ? record.target_data[index].target : '-'}</span>
    )
}

const Rebate = ({ record = {}, source, index }) => {
    return (
        <span>{record.target_data[index] ? record.target_data[index].rebate : '-'}</span>
    )
}

const Target1 = ({ record = {}, source, index }) => {
    return (
        <span>{record.target_data[0] ? record.target_data[0].target : '-'}</span>
    )
}
const Target2 = ({ record = {}, source, index }) => {
    return (
        <span>{record.target_data[1] ? record.target_data[1].target : '-'}</span>
    )
}
const Rebate1 = ({ record = {}, source, index }) => {
    return (
        <span>{record.target_data[0] ? record.target_data[0].rebate : '-'}</span>
    )
}
const Rebate2 = ({ record = {}, source, index }) => {
    return (
        <span>{record.target_data[1] ? record.target_data[1].rebate : '-'}</span>
    )
}

const MonthName = ({ record = {} }) => {
    return (
        <span>{monthList[Number(record.month)-1]}</span>
    )
}


class BusinessTargetsList extends Component {


    render() {
        const { props, permissions } = this;
        const noOftargets = [...Array(3).keys()];
        let roleData = GetCurrentUserRoles();
        let editBtn = false;
        if (roleData.indexOf("$csa") > -1 || roleData.indexOf("$ca") > -1) {
            editBtn = true
        }
        return (
            <React.Fragment>
                <Scrollbars class="scroll-container">
                    <List {...props} exporter={this.exporter} sort={{ field: 'created_at', order: 'DESC' }} undoable={false} filters={<BusinesstargetsFilter />} title="Business Targets" bulkActionButtons={false} actions={<ListActions permissions={permissions} />} >
                        <Datagrid>
                            {/* <UserName label="Sales Officers Name" /> */}
                            <TextField source="sold_to_code" 
                            // label="Sold To ID" 
                            />
                            <ReferenceField label="Sold To Name" source="business_id" reference="businesses" link="show" allowEmpty >
                                <TextField source="name" />
                            </ReferenceField>
                            <MonthName source="month" label="Month" />
                            <TextField source="year" label="Year" />
                            <TextField source="tonnage" default="-" />


                            <Target1 source="target_data" label="Target 1" sortable={false} />
                            <Rebate1 source="target_data" label="Rebate 1" sortable={false} />
                            <Target2 source="target_data" label="Target 2" sortable={false} />
                            <Rebate2 source="target_data" label="Rebate 2" sortable={false} />

                            {/* {
                                noOftargets.map((item, index) => (
                                    <Target source="target_data" label={`Target ${index + 1}`} index={index} />
                                ))
                            }
                            {
                                noOftargets.map((item, index) => (
                                    <Rebate source="target_data" label={`Rebate ${index + 1}`} index={index} />
                                ))
                            } */}

                            <DateField 
                            source="created_at" 
                            // label="Record Created At" 
                            showTime={true} />
                            {
                                editBtn &&
                                <EditButton />
                            }
                            {
                                editBtn &&
                                <DeleteButton />    
                            }
                        </Datagrid>
                    </List>
                </Scrollbars>
            </React.Fragment>
        )
    }
}

export default BusinessTargetsList;